import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import WunaLoader from '../common/WunaLoader/WunaLoader';
import { getReturnUrl, removeReturnUrl } from 'utils/authCookie';
const Layout = React.lazy(() => import('components/Authenticated/Layout'));

export default function Authenticated() {
  const redirectUrl = getReturnUrl();
  const navigate = useNavigate();
  if (redirectUrl) {
    navigate(redirectUrl);
    removeReturnUrl();
  }
  return (
    <Suspense fallback={<WunaLoader />}>
      <Layout />
    </Suspense>
  );
}
